// Copyright 2017 Sorama B.V.

import { autoinject, bindable, computedFrom, customElement } from "aurelia-framework";
import DOMPurify from "dompurify";

@customElement("alert")
@autoinject
export class Alert {
    constructor() {}
    @bindable public alertType?: string;
    @bindable public alertText?: string;
    @bindable public alertSubText?: string | string[];
    @bindable public alertIcon?: string;
    @bindable public alertLoading?: boolean;
    @bindable public secondaryIcon?: string;
    @bindable public clickAction?: () => void;
    @bindable public closeAction?: () => void;

    @computedFrom("alertSubText")
    protected get alertSubItems(): string[] {
        if (!this.alertSubText) return [];
        return Array.isArray(this.alertSubText)
            ? this.alertSubText.map((item) => this.sanitize(item))
            : [this.sanitize(this.alertSubText)];
    }

    private sanitize(text: string): string {
        return DOMPurify.sanitize(text);
    }
}
